export const HOME_SPLASH_GET_STARTED_BUTTON_SHADOW: string =
  '0 0.5px 1px rgba(255, 255, 255, 0.1), 0 1px 2px rgba(255, 255, 255, 0.15)'
export const HOME_SPLASH_GET_STARTED_BUTTON_BORDER_RADIUS: string =
  '8px 8px 8px 8px'
export const MANTINE_DARK_COLORS_THEME: any = [
  '#d5d7e0',
  '#acaebf',
  '#8c8fa3',
  '#666980',
  '#4d4f66',
  '#34354a',
  '#2b2c3d',
  '#000000',
  '#000000',
  '#000000',
]
export const MEDIUM_BUTTON_RADIUS: string = '6px 6px 6px 6px'
export const MEDIUM_BUTTON_BOX_SHADOW: string =
  '0 3px 6px rgba(255, 255, 255, 0.2), 0 2px 3px rgba(255, 255, 255, 0.15)'
export const MEDIUM_BUTTON_BORDER_BOTTOM_DARK: string = '6px solid #bbbb02ff'
export const MEDIUM_BUTTON_DISABLED_BORDER_BOTTOM: string = 'initial'
export const MEDIUM_BUTTON_DISABLED_BOX_SHADOW: string = 'initial'
